import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType,
    SettingState,
    SettingOption,
} from '@appblocks/codegeneration/types';

export default class CustomFeatureVariable extends BaseFeature {
    constructor() {
        super();
        this.name = 'Custom Feature Variable';
        this.id = 'custom_feature_variable';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'GENERAL',
                name: 'General',
                settingType: SettingType.GROUP,
                required: true,
                default: '',
            },
            {
                id: 'ADVANCED',
                name: 'Advanced',
                settingType: SettingType.GROUP,
                required: true,
                default: '',
            },
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                group: 'GENERAL',
                required: true,
                default: '',
            },
            {
                id: 'DATA_TYPE',
                name: 'Data Type',
                settingType: SettingType.OPTION,
                required: true,
                group: 'GENERAL',
                default: 'string',
                options: [
                    {
                        name: 'String',
                        value: 'string',
                    },
                    {
                        name: 'Byte',
                        value: 'byte',
                    },
                    {
                        name: 'Float',
                        value: 'float',
                    },
                    {
                        name: 'Integer',
                        value: 'integer',
                    },
                    {
                        name: 'Boolean',
                        value: 'boolean',
                    },
                ],
            },
            {
                id: 'DESCRIPTION',
                name: 'Description',
                settingType: SettingType.STRING,
                group: 'GENERAL',
                required: true,
                default: '',
            },
        ]);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        return blocks;
    }
}
